import { Swiper } from "swiper";
import { Navigation } from "swiper/modules";

export default class SliderHannes {
  constructor() {}

  static initAll() {
    const sliderBaseContainers = document.querySelectorAll(".slider-hannes.swiper");
    if (sliderBaseContainers.length === 0) return;

    const createSegments = (swiper) => {
      const progressBar = swiper.el.querySelector(".progress-bar");
      progressBar.innerHTML = "";

      const totalSlides = swiper.slides.length;
      const perView = swiper.params.slidesPerView;

      // number of actual slide positions
      const segmentCount = Math.max(1, totalSlides - perView + 1);

      for (let i = 0; i < segmentCount; i++) {
        const seg = document.createElement("div");
        seg.classList.add("progress-segment");
        progressBar.appendChild(seg);
      }
    };

    const updateSegments = (swiper) => {
      const segments = swiper.el.querySelectorAll(".progress-segment");

      // Make the active segment follow swiper's index,
      // but clamp to segment count
      const maxIndex = segments.length - 1;
      const current = Math.min(swiper.realIndex, maxIndex);

      segments.forEach((seg, i) => {
        seg.classList.toggle("active", i === current);
      });
    };

    const config = {
      modules: [Navigation],
      navigation: {
        prevEl: ".swiper-button-prev-hannes",
        nextEl: ".swiper-button-next-hannes",
      },
      slidesPerView: 1,
      spaceBetween: 30,
      on: {
        init(swiper) {
          createSegments(swiper);
          updateSegments(swiper);
        },
        slideChange(swiper) {
          updateSegments(swiper);
        },
        resize(swiper) {
          createSegments(swiper);
          updateSegments(swiper);
        }
      },
      breakpoints: {
        768: { slidesPerView: 2, spaceBetween: 30 },
        1024: { slidesPerView: 2, spaceBetween: 50 },
        1536: { slidesPerView: 3, spaceBetween: 50 }
      },
    };

    sliderBaseContainers.forEach((container) => {
      new Swiper(container, config);
    });
  }
}
